<dx-popup
    [width]="width"
    [height]="height"
    [showTitle]="showTitle()"
    [title]="title"
    [dragEnabled]="allowDrag"
    [resizeEnabled]="allowResize"
    [showCloseButton]="showCloseButton"
    [(visible)]="visible"
    (onHiding)="hiding($event)"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box [visible]="!webcamVisible" direction="col" height="100%" width="100%">
            <dxi-item [ratio]="1">
                <div *ngIf="disableAction">
                    <dx-box direction="row" height="100%" width="100%" align="center" crossAlign="center">
                        <dxi-item baseSize="auto" *ngIf="webcamAvailable">
                            <dx-button icon="photo" (onClick)="showWebcam()" hint="Camera"></dx-button>
                        </dxi-item>
                        <dxi-item [ratio]="1">
                            <dx-file-uploader
                                class="drop-zone-border dx-theme-border-color"
                                [width]="240"
                                selectButtonText="Browse"
                                labelText="or Drop file here"
                                accept="image/*"
                                [allowedFileExtensions]="['.jpg', '.jpeg', '.gif', '.png']"
                                uploadMode="useForm"
                                [showFileList]="false"
                                [allowCanceling]="false"
                                (onValueChanged)="imageFileSelected($event)"
                            ></dx-file-uploader>
                        </dxi-item>
                        <dxi-item baseSize="auto" *ngIf="isIOSDevice">
                            <dx-button
                                class="camera-information-button"
                                type="default"
                                icon="info"
                                hint="Camera Information"
                                (onClick)="showWebcamInfo()"
                            ></dx-button>
                        </dxi-item>
                    </dx-box>
                </div>

                <div *ngIf="!disableAction">
                    <dx-toolbar>
                        <dxi-item
                            location="center"
                            widget="dxButton"
                            [options]="{
                                icon: 'revert',
                                hint: 'Rotate Left',
                                onClick: rotateLeft
                            }"
                        ></dxi-item>
                        <dxi-item
                            location="center"
                            widget="dxButton"
                            [options]="{
                                icon: 'redo',
                                hint: 'Rotate Right',
                                onClick: rotateRight
                            }"
                        ></dxi-item>
                        <dxi-item
                            location="center"
                            widget="dxButton"
                            [options]="{
                                icon: 'chevronnext',
                                hint: 'Flip Horizontal',
                                onClick: flipHorizontal
                            }"
                        ></dxi-item>
                        <dxi-item
                            location="center"
                            widget="dxButton"
                            [options]="{
                                icon: 'chevrondown',
                                hint: 'Flip Vertical',
                                onClick: flipVertical
                            }"
                        ></dxi-item>
                        <dxi-item
                            location="center"
                            widget="dxButton"
                            [options]="{
                                icon: 'clear',
                                hint: 'Clear Image',
                                onClick: clearImage
                            }"
                        ></dxi-item>
                    </dx-toolbar>
                </div>
                <div class="image-cropper-container">
                    <image-cropper
                        #ccImageCropper
                        class="image-cropper"
                        [imageFileChanged]="selectedImageFile"
                        [imageBase64]="selectedImageBase64"
                        [maintainAspectRatio]="true"
                        [aspectRatio]="1 / 1"
                        [resizeToWidth]="128"
                        [cropperMinWidth]="128"
                        [roundCropper]="true"
                        [autoCrop]="false"
                        format="png"
                        outputType="base64"
                        (imageCropped)="imageCropped($event)"
                        (imageLoaded)="imageLoaded()"
                        (cropperReady)="cropperReady()"
                        (loadImageFailed)="loadImageFailed()"
                        [style.display]="showCropper ? null : 'none'"
                    ></image-cropper>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <dx-box direction="row" width="100%" align="end" crossAlign="center">
                    <dxi-item [ratio]="1">
                        <dx-button type="default" [width]="100" text="Cancel" (onClick)="hide()"></dx-button>
                    </dxi-item>
                    <dxi-item baseSize="auto">
                        <dx-button
                            type="success"
                            [width]="100"
                            text="Crop & Save"
                            [disabled]="disableAction"
                            (onClick)="cropImage()"
                        ></dx-button>
                    </dxi-item>
                </dx-box>
            </dxi-item>
        </dx-box>
        <cc-web-cam
            [visible]="webcamVisible"
            (imageCaptured)="webcamImageCaptured($event)"
            (closed)="webcamClosed()"
        ></cc-web-cam>
    </div>
</dx-popup>

<dx-popup
    [width]="width"
    [height]="height"
    [showTitle]="true"
    title="Camera Information"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [showCloseButton]="true"
    [visible]="webcamInfoVisible"
>
    <dx-box width="100%" height="100%" direction="col">
        <dxi-item [ratio]="1">
            <div class="camera-information-items-center">
                <h4>Make sure to hold your device as shown in below image</h4>
                <img
                    alt=""
                    src="data:image/svg+xml;base64,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"
                />
            </div>
        </dxi-item>
        <dxi-item baseSize="auto">
            <div class="camera-information-items-center">
                <dx-button
                    [width]="100"
                    text="Ok"
                    icon="fas fa-check"
                    type="default"
                    (onClick)="closeWebcamInfo()"
                ></dx-button>
            </div>
        </dxi-item>
    </dx-box>
</dx-popup>
